import { render, staticRenderFns } from "./Blocks.vue?vue&type=template&id=8c840726&scoped=true"
import script from "./Blocks.vue?vue&type=script&lang=js"
export * from "./Blocks.vue?vue&type=script&lang=js"
import style0 from "./Blocks.vue?vue&type=style&index=0&id=8c840726&prod&lang=scss&scoped=true"
import style1 from "./Blocks.vue?vue&type=style&index=1&id=8c840726&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c840726",
  null
  
)

export default component.exports